import React from 'react';
import { YaSplitInfo } from 'types/page-model';
import { yandexSplitContainer, textContainer, withPrice, smallPadding, yandexSplitLogo } from './styles';
import { getIsBot } from 'common/selectors';
import { getCurrency, getDivisionId, getSource } from 'features/product-info';
import { useSelector } from 'react-redux';
import { RegularButton, Typography } from 'fronton-react';
import { cx } from 'linaria';
import { getLocale } from 'utils';
import { formatPrice } from './utils';

const xSymbol = 'х';

export type Props = {
  yaSplitInfo: YaSplitInfo;
  price?: number | null;
  currency?: string;
};

export const YandexSplitBanner: React.FC<Props> = ({
  yaSplitInfo: {
    enabled,
    mainText,
    priceBreakThreshold,
    maxPriceThreshold,
    splitCount,
    linkPage: { href },
    logoLink,
    KindDivisionsList,
    KindSourceList,
  },
  price,
}) => {
  const isBot = useSelector(getIsBot);
  const currentDivision = String(useSelector(getDivisionId));
  const currentSource = useSelector(getSource)?.toLowerCase();
  const currency = useSelector(getCurrency) || 'RUB';

  if (isBot || !enabled || !price) return null;
  if (price > maxPriceThreshold) return null;

  const isExcludedDivision = KindDivisionsList.some((d) => String(d) === currentDivision);
  const isExcludedSource = KindSourceList.some((s) => s.toLowerCase() === currentSource);

  if (isExcludedDivision || isExcludedSource) return null;

  const showPrice = price >= priceBreakThreshold;

  const logoSize = showPrice ? 20 : 16;

  let splitPriceFormatted;
  const locale = getLocale();

  if (showPrice) {
    const splitPrice = price / splitCount;
    splitPriceFormatted = formatPrice(splitPrice, currency, locale);
  }

  return (
    <RegularButton
      href={href}
      variant="secondary"
      className={showPrice ? yandexSplitContainer : cx(yandexSplitContainer, smallPadding)}
    >
      <img
        className={yandexSplitLogo}
        src={logoLink}
        alt="Логотип Yandex Split"
        width={logoSize}
        height={logoSize}
      />
      <div className={showPrice ? cx(textContainer, withPrice) : textContainer}>
        {showPrice && (
          <Typography color="text-primary" size="body_accent" variant="s">
            {splitPriceFormatted} {xSymbol} {splitCount}
          </Typography>
        )}
        <Typography color="text-primary" size="caption" variant="minor">
          {mainText}
        </Typography>
      </div>
    </RegularButton>
  );
};
